// extracted by mini-css-extract-plugin
export default {"credit-exchange-rate-space":"credit-exchange-rate-space__cLlq","left-col":"left-col_UdZVA","right-col":"right-col_J91uQ","edit-button":"edit-button_z14IC"};